<ion-menu contentId="tab-main-content"
          class="mobile-menu-wrapper">
    <ion-content class="side-menu ion-padding p-3 custom-sidebar-styl"
                 [scrollEvents]="true">
        <div class="top-content ion-padding-horizontal header d-flex align-items-center justify-content-between">
            <img class="k-logo"
                 src="assets/images/kotak-logo.svg"
                 alt="kotak-logo" />
            <img src="assets/icon/back.svg"
                 alt="back"
                 (click)="toggleMenu()" />
        </div>
        <bh-side-panel [sideMenuItems]="sideMenuItems"></bh-side-panel>
        <div class="bottom-content px-3 mt-3 pb-4">
            <ion-text color="secondary"
                      class="bottom-content-header font-16 weight-400 pb-2">© Kotak Mutual Fund {{this.systemService.currentYear}}</ion-text>
            <ion-text class="bottom-content-para font-12 weight-400">MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL SCHEME RELATED DOCUMENTS CAREFULLY.</ion-text>
        </div>
    </ion-content>
</ion-menu>

<div class="d-block app-bottom-tabs">
    <ion-tabs id="tab-main-content">
        <ion-tab-bar slot="bottom"
                     class="tab-bar d-flex d-lg-none"
                     *ngIf="showTabs">
            <ion-tab-button [ngClass]="{ selected: highlighMenu }"
                            (click)="toggleMenu()">
                <img src="assets/icon/tabs/menu.svg"
                     alt="menu" />
                <ion-label>Menu</ion-label>
            </ion-tab-button>
            <ng-container *ngFor="let item of tabInfo; let i = index">
                <ion-tab-button [ngClass]="{ selected: item.selected }"
                                *ngIf="item.show"
                                (click)="item.routeTo && navigateTo(item)">
                    <img [src]="item.image"
                         [alt]="item.name" />
                    <ion-label class="tab-bar-label">{{ item.name }}</ion-label>
                </ion-tab-button>
            </ng-container>


        </ion-tab-bar>
    </ion-tabs>
</div>